import { LoadingButton } from '@mui/lab'
import { Button, SxProps, Theme, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import useGetAuthSessionQuery from '~/features/auth/hooks/useGetAuthSessionQuery'
import { EClientPath } from '~/models/api'

type TProps = {
  sx?: SxProps<Theme>
  navigateTo?: EClientPath
  text?: string
  isPartnerThemed?: boolean
} & React.ComponentProps<typeof Button>

function AuthButton({
  sx = {},
  navigateTo = EClientPath.login,
  text = 'Dashboard',
  isPartnerThemed = false,
  ...buttonProps
}: TProps) {
  const navigate = useNavigate()
  const theme = useTheme()
  const { data: authSession, isLoading: isFetchingAuthSession } =
    useGetAuthSessionQuery()
  const isLoggedIn = authSession?.email

  const isNoSmallScreen = useMediaQuery(theme.breakpoints.up('md'))

  if (isFetchingAuthSession && !isLoggedIn) {
    return (
      <LoadingButton
        loading
        variant={
          buttonProps.variant ||
          (isNoSmallScreen ? 'secondaryDark' : 'tertiary1')
        }
        size="small"
        sx={{
          '& .MuiLoadingButton-loadingIndicator': {
            color: theme.palette.menuIcon,
          },
          flexShrink: 0,
          ...sx,
        }}
      >
        {text}
      </LoadingButton>
    )
  }

  if (isLoggedIn) {
    return null
  }

  return (
    <Button
      variant={
        buttonProps.variant || (isNoSmallScreen ? 'secondaryDark' : 'tertiary1')
      }
      size="small"
      sx={{
        flexShrink: 0,
        ...sx,
      }}
      onClick={() => navigate(navigateTo, { state: { isPartnerThemed } })}
      {...buttonProps}
    >
      {text}
    </Button>
  )
}

export default AuthButton
